
import { Components } from "../Framework/Components";
import * as Application from "../App";
import * as Layout_SideBar from "../Layout/SideBar";
import * as Template from "../Framework/Template";
import "jquery-pjax";

export module Pjax {

    export async function initAllAsync(container: JQuery): Promise<void> {

        var count = container.find('a[href]:not([download])').not("[target = '_blank']").not(".no-pjax").length;

        return new Promise<void>((resolve, reject) => {

            if (count == 0)
                resolve();

            var contentSelector = "#divPjaxContent";

            var options = <PjaxSettings>{
                scrollTo: 0,
                timeout: 10000,
                fragment: contentSelector,
                container: contentSelector,
                maxCacheLength: 0
            };

            if (!$(options.container || "#Q_Qqqq_Q").length)
                resolve();
            else {

                $.pjax.defaults.maxCacheLength = 0;

                if ($.support.pjax) {
                    $(container).find('a[href]:not([download])').not("[target = '_blank']").not(".no-pjax").on('click', function (event: any) {
                        if ((window as any).bulkUploadStarted === true) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.cancelBubble = true;
                            alert("Upload in progress!");
                            return;
                        }
                        else {
                            $.pjax.click(event, contentSelector, options);
                            event.preventDefault();
                            event.stopPropagation();
                            event.cancelBubble = true;
                        }
                    })
                }


                //$(container).pjax("a[href]", contentSelector, options);
                $(contentSelector)
                    .on("pjax:send", () => {
                        $("body").removeClass("loaded").removeClass("sidebar-mobile-show").addClass("sidebar-mobile-hidden");
                        $("#divPjaxContent").removeClass("of-y-auto");

                        $(".header-dropdown .dropdown a.nav-link").each((i, e) => {
                            if ($(e).siblings(".dropdown-menu").hasClass("show"))
                                $(e).click();
                        });

                    })
                    .on("pjax:complete", async () => {
                        return false;
                    })
                    .on("pjax:end", async (e) => {


                        if ($("body").hasClass("loaded"))
                            return;

                        $("body").addClass("loaded");
                        $("#divPjaxContent").addClass("of-y-auto");

                        //console.log("pjax:end");

                        var sideBar = Components.getByElement($("#sidebar[data-js-type='Layout.Sidebar']"));
                        if (sideBar != null)
                            (<Layout_SideBar.Layout.Sidebar>sideBar).close();

                        Template.Template.setActiveSidebar();

                        Components.clearObjectCacheByContainer($(contentSelector));
                        if (Application.App)
                            await Application.App.initAppAsync(container, false);
                        else
                            await (<any>Application).default.App.initAppAsync(container, false);


                    });

                resolve();
            }
        });

    }
}
